<template>
  <slot />
</template>

<script>
  import { mapActions } from 'vuex';

  import { isExpiredIndicatorMenuItem } from '@/common/store/expiredIndicator/menuItem';
  import { EXPIRED_INDICATOR_ACTIONS_NAME } from '@/common/store/expiredIndicator/name';

  export default {
    name: 'ExpiredIndicatorProvider',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        isFetched: false,
      };
    },
    methods: {
      ...mapActions({
        fetchExpiredIndicator: EXPIRED_INDICATOR_ACTIONS_NAME.fetchExpiredIndicator,
      }),
      checkAndFetch(items) {
        if (this.isFetched) return;
        if (Array.isArray(items) && items.some(isExpiredIndicatorMenuItem)) {
          this.isFetched = true;
          this.fetchExpiredIndicator();
        }
      },
    },
    watch: {
      items: {
        handler(newItems) {
          this.checkAndFetch(newItems);
        },
        immediate: true,
      },
    },
  };
</script>
